import { AVAILABLE_TEST_TARGETS } from "../Store";

export const sortTests = (tests) => {
    const sortedTests = [...tests].sort((a, b) => {
        return AVAILABLE_TEST_TARGETS.indexOf(a.testTarget) - AVAILABLE_TEST_TARGETS.indexOf(b.testTarget);
    });
    return sortedTests;
};

export const getFormattedTestNames = (testTarget, t) => {
    if (testTarget === "fluA") {
        return `${t("flu")} A`;
    } else if (testTarget === "fluB") {
        return `${t("flu")} B`;
    } else if (testTarget === "rsv") {
        return `${t("rsv")}`;
    }
    return t("covid");
};
